import React, { useState } from "react";
import L from "leaflet";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import { MaterialIcon, Toaster } from "ui-widgets";
import BoundaryOrPoint from "models/explorer/boundary-or-point";
import ModalControlProps from "models/explorer/modal-control-props";
import ExplorerService from "services/ExplorerService";

const { explorerService } = new ExplorerService();

const ExplorerSearchButton = (modalControlProps: ModalControlProps) => {
  const { searchFeatures, customSearch, setPointsAndBoundaries } =
    modalControlProps;
  const [open, setOpen] = useState(false);

  const saveResults = (boundaryOrPoints: BoundaryOrPoint[]) => {
    !boundaryOrPoints
      ? Toaster.makeToast("Error in search", "error")
      : boundaryOrPoints.length
        ? setPointsAndBoundaries(
            boundaryOrPoints.map((boundaryOrPoint) => {
              const leafletGeojson =
                boundaryOrPoint.type === "boundary"
                  ? boundaryOrPoint.geojson
                    ? L.GeoJSON.coordsToLatLngs(
                        JSON.parse(boundaryOrPoint.geojson)?.coordinates,
                        2,
                      )
                    : []
                  : [];
              return {
                ...boundaryOrPoint,
                leafletGeojson: leafletGeojson,
                styling: {
                  ...boundaryOrPoint.styling,
                  colour: `#${(0x1000000 + Math.random() * 0xffffff).toString(16).substring(1, 7)}`,
                },
              };
            }),
          )
        : Toaster.makeToast("No results found", "warning");
  };

  function StartSearch() {
    const manyResultMessage = () =>
      Toaster.makeToast(
        "Found more than 1000 results! Your results may be limited. Please reduce the size of your search or include tags.",
        "warning",
        10000,
      );
    setPointsAndBoundaries([]);
    if (customSearch.latlong) {
      setOpen(true);
      explorerService
        .circleSearch(
          customSearch.latlong.lat,
          customSearch.latlong.lng,
          customSearch.radius,
          searchFeatures.tags ?? [],
        )
        .then((res) => {
          saveResults(res);
          if (res.length >= 1000) {
            manyResultMessage();
          }
        })
        .catch((res) => Toaster.makeToast(res.message, "error"))
        .finally(() => setOpen(false));
    } else if (customSearch.geojson) {
      setOpen(true);
      explorerService
        .polysearch(
          JSON.stringify(customSearch.geojson),
          searchFeatures.containedOrIntersecting,
          searchFeatures.tags ?? [],
        )
        .then((res) => {
          saveResults(res);
          if (res.length >= 1000) {
            manyResultMessage();
          }
        })
        .catch((res) => Toaster.makeToast(res.message, "error"))
        .finally(() => setOpen(false));
    } else if (customSearch.boundary_guid) {
      setOpen(true);
      explorerService
        .boundary_search(
          customSearch.boundary_guid,
          searchFeatures.containedOrIntersecting,
          searchFeatures.tags ?? [],
        )
        .then((res) => {
          saveResults(res);
          if (res.length >= 1000) {
            manyResultMessage();
          }
        })
        .catch((res) => Toaster.makeToast(res.message, "error"))
        .finally(() => setOpen(false));
    }
  }
  return (
    <>
      <Button
        disabled={!customSearch.enabled && customSearch.radius < 1}
        onClick={StartSearch}
        endIcon={<MaterialIcon icon="search" />}
        sx={{ marginLeft: "auto" }}
        variant="contained"
      >
        Search
      </Button>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ExplorerSearchButton;
